/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function VideoDeliveryItemEditViewAudioChannelMapsListController(
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    AudioChannelMappingService: JS5Object
) {

    const NUMBER_OF_INPUT_OUTPUT_CHANNELS = 32;
    let allAudioChannelMaps: JS5Object[];
    let prevChannelMapGroup: JS5Object;
    let channelMapsInitialized = false;

    const getChannelMaps = () => {
        if (!this.channelMapGroup.audioChannelMaps) {
            this.channelMapGroup.audioChannelMaps = [];
        }
        return this.channelMapGroup.audioChannelMaps;
    };

    const updateInputValidity = (channelMaps: JS5Object[]) => {
        let inputsValidity: JS5Object = {};
        let areInputsUnique: boolean = _.every(channelMaps, (channelMap: JS5Object) => {
            inputsValidity[channelMap.input] = !inputsValidity[channelMap.input];
            return inputsValidity[channelMap.input];
        });
        this.editorForm.$setValidity('repeatedInput', areInputsUnique);
    };

    this.updateViewData = () => {
        prevChannelMapGroup = this.channelMapGroup;
        if (!this.channelMapGroup) {
            return;
        }
        let channelMaps = getChannelMaps();

        parseAudioChannelMaps(channelMaps);
        if (!channelMapsInitialized) {
            this.showUnassignedAudioChannelMaps = _.every(allAudioChannelMaps, (audioChannelMap: JS5Object) => {
                return _.isNil(audioChannelMap.input);
            });
            $timeout(() => updateInputValidity(channelMaps));
        } else {
            updateInputValidity(channelMaps);
        }
        this.updateVisibleChannelMaps();
        channelMapsInitialized = true;
    };


    //======================//
    // Channel Map Handling //
    //======================//

    this.updateVisibleChannelMaps = () => {
        this.visibleAudioChannelMaps = _.filter(allAudioChannelMaps, (channelMap: JS5Object) => {
            return this.showUnassignedAudioChannelMaps || !_.isNil(channelMap.input);
        });
    };

    const removeEmptyAudioChannelMapDTO = (channelMaps: JS5Object[], audioChannelMap: JS5Object) => {
        let channelMapId: string = _.get(audioChannelMap, 'id');
        let alternateId: string = _.get(audioChannelMap, 'output');
        if (channelMapId) {
            _.pullAllBy(channelMaps, [{id: channelMapId}], 'id');
        } else if (alternateId) {
            _.pullAllBy(channelMaps, [{output: alternateId}], 'output');
        }
    };

    const parseAudioChannelMaps = (channelMaps: JS5Object[]) => {
        allAudioChannelMaps = [];
        this.visibleAudioChannelMaps = [];
        let orderedChannelMaps = _.groupBy(channelMaps, (channelMap: JS5Object) => parseInt(channelMap.output));
        for (let outputChannel = 0; outputChannel < NUMBER_OF_INPUT_OUTPUT_CHANNELS; ++outputChannel) {
            let possibleChannelMaps: JS5Object = _.get(orderedChannelMaps, outputChannel, []);
            let chosenChannelMap = possibleChannelMaps.shift();
            let inputChannelBase0 = _.chain(chosenChannelMap)
                .get('input')
                .parseInt()
                .value();
            if (chosenChannelMap && !isNaN(inputChannelBase0)) {
                chosenChannelMap._userInput = inputChannelBase0 +1;
            } else if (chosenChannelMap) {
                removeEmptyAudioChannelMapDTO(channelMaps, chosenChannelMap);
                chosenChannelMap = undefined;
            }

            if (!chosenChannelMap) {
                chosenChannelMap = {output: `${outputChannel}`};
            }
            allAudioChannelMaps.push(chosenChannelMap);
            _.forEach(possibleChannelMaps, (leftoverMap: JS5Object) => removeEmptyAudioChannelMapDTO(channelMaps, leftoverMap));
        }
        _.forEach(orderedChannelMaps, (leftoverChannelMaps: JS5Object[]) => {
            _.forEach(leftoverChannelMaps, (leftoverMap: JS5Object) => removeEmptyAudioChannelMapDTO(channelMaps, leftoverMap));
        });
    };


    //=====================//
    // Input Channel Field //
    //=====================//

    this.isInputDisabled = (audioChannelMap: JS5Object) => {
        let outputChannelOwner = AudioChannelMappingService.getChannelGroupFromOutputChannel(audioChannelMap.output);
        return this.isDisabled || (!_.isNil(outputChannelOwner) && outputChannelOwner !== this.channelMapGroup);
    };

    this.onInputChange = (audioChannelMap: JS5Object) => {
        let channelMaps = getChannelMaps();
        let userInput = audioChannelMap._userInput;

        if (!_.isNil(userInput)) {
            if (!audioChannelMap.input) {
                channelMaps.push(audioChannelMap);
            }
            audioChannelMap.input = `${userInput -1}`;

        } else {
            removeEmptyAudioChannelMapDTO(channelMaps, audioChannelMap);
            delete audioChannelMap.input;
        }

        updateInputValidity(channelMaps);
        AudioChannelMappingService.onChannelUpdate(this.channelMapGroup, audioChannelMap.output);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        AudioChannelMappingService.registerRevertDataCallback(this.onDataReset);
        this.updateViewData();
    };

    this.$onDestroy = () => {
        AudioChannelMappingService.unregisterRevertDataCallback(this.onDataReset);
    };

    this.$doCheck = () => {
        if (prevChannelMapGroup !== this.channelMapGroup) {
            this.updateViewData();
        }
    };

    this.onDataReset = () => {
        channelMapsInitialized = false;
    };

}

angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMapsList', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/deliveryItemsVideoEditViewAudioChannelMapsListComponent/delivery-items-video-edit-view-audio-channel-maps-list-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMapsListController,
    bindings: {
        channelMapGroup: '=',
        isDisabled: '<ngDisabled'
    }
});
